import site_context_uk from '@fixtures/site_context/site_context_uk.fixture.json';

import LinkedAccounts from './LinkedAccounts';
import providerLogos from './providerLogos/index';
import IwModals from '../../../iwModals/IwModals';
import IwProvider from '../../../iwProvider/IwProvider';
import IwRouter from '../../../iwRouter/index';
import IwSiteContext from '../../../iwSiteContext/IwSiteContext';
import { mockTradingDataAPI } from '../TradingData.testHelpers';

export function getLogoFromProvider(provider) {
    if (providerLogos[provider]) {
        return providerLogos[provider];
    } else {
        return providerLogos.fallback;
    }
}

function createLinkedAccounts(onlineAccounts) {
    mockTradingDataAPI({ onlineAccountFixture: onlineAccounts });

    return (
        <IwProvider>
            <IwSiteContext siteContext={site_context_uk}>
                <IwRouter
                    initialURL="/trading/"
                    disableFirstRouterChange={true}
                >
                    <LinkedAccounts />
                    <IwModals />
                </IwRouter>
            </IwSiteContext>
        </IwProvider>
    );
}

export function createLinkedAccountsOneBank() {
    const onlineAccounts = {
        data: [
            {
                // @ts-expect-error bank_name doesn't exist on object. Needs removing/fixing
                bank_name: 'Lloyds Bank',
                online_account_id: 'd4dce997-54e5-47a3-8c15-f88d0dc56c56',
                provider: 'Lloyds Bank',
                linked_at: '2018-12-04T15:49:13Z',
                status: {
                    code: 'active'
                },
                accounts: [
                    {
                        name: '',
                        updated_at: '2023-10-01T12:00:00Z',
                        extra: {
                            balance: 978.05,
                            account_number: '87654321'
                        }
                    }
                ]
            }
        ]
    };

    return createLinkedAccounts(onlineAccounts);
}

export function createLinkedAccountsTrueLayerBank() {
    const onlineAccounts = {
        data: [
            {
                // @ts-expect-error bank_name doesn't exist on object. Needs removing/fixing
                bank_name: 'Amex',
                online_account_id: 'oauth-amex',
                provider: 'Amex',
                linked_at: '2018-12-04T15:49:13Z',
                status: {
                    code: 'active'
                },
                logo_url:
                    'https://truelayer-provider-assets.s3.amazonaws.com/global/logos/amex.svg',
                accounts: [
                    {
                        name: '',
                        updated_at: '2023-10-01T12:00:00Z',
                        extra: {
                            balance: 978.05,
                            account_number: '03818531'
                        }
                    }
                ]
            }
        ]
    };

    return createLinkedAccounts(onlineAccounts);
}

export function createLinkedAccountsMultipleBank() {
    const onlineAccounts = {
        data: [
            {
                // @ts-expect-error bank_name doesn't exist on object. Needs removing/fixing
                bank_name: 'Lloyds Bank',
                online_account_id: 'PROVIDER_ID_LLOYDS',
                provider: 'Lloyds Bank',
                linked_at: '2018-12-04T15:49:13Z',
                status: {
                    code: 'active'
                },
                accounts: [
                    {
                        name: 'Lloyds Bank',
                        updated_at: '2023-10-01T12:00:00Z',
                        extra: {
                            balance: 978.05,
                            account_number: '87654321'
                        }
                    }
                ]
            },
            {
                // @ts-expect-error bank_name doesn't exist on object. Needs removing/fixing
                bank_name: 'HSBC Bank',
                online_account_id: 'PROVIDER_ID_HSBC',
                provider: 'HSBC',
                linked_at: '2018-12-04T15:49:13Z',
                status: {
                    code: 'active'
                },
                accounts: [
                    {
                        name: 'HSBC Bank',
                        updated_at: '2023-10-01T12:00:00Z',
                        extra: {
                            balance: 1000.0,
                            account_number: '12345678'
                        }
                    }
                ]
            },
            {
                // @ts-expect-error bank_name doesn't exist on object. Needs removing/fixing
                bank_name: 'Barclays Bank',
                online_account_id: 'PROVIDER_ID_BARCLAYS',
                provider: 'Barclays',
                linked_at: '2018-12-04T15:49:13Z',
                status: {
                    code: 'active'
                },
                accounts: [
                    {
                        name: 'Barclays Bank',
                        updated_at: '2023-10-01T12:00:00Z',
                        extra: {
                            balance: 99999.99,
                            account_number: '11111111'
                        }
                    }
                ]
            }
        ]
    };

    return createLinkedAccounts(onlineAccounts);
}

export function createLinkedAccountsFallback() {
    const onlineAccounts = {
        data: [
            {
                // @ts-expect-error bank_name doesn't exist on object. Needs removing/fixing
                bank_name: 'Mock',
                online_account_id: 'PROVIDER_ID_LLOYDS',
                provider: 'Mock',
                linked_at: '2018-12-04T15:49:13Z',
                status: {
                    code: 'active'
                },
                accounts: [
                    {
                        name: 'Mock',
                        updated_at: '2023-10-01T12:00:00Z',
                        extra: {
                            balance: 978.05,
                            account_number: '87654321'
                        }
                    }
                ]
            }
        ]
    };

    return createLinkedAccounts(onlineAccounts);
}

export function createLinkedAccountsNoProviders() {
    const linkedAccounts = createLinkedAccounts();
    return <div className="wrapper-div">{linkedAccounts}</div>;
}
